import React, { useState, useEffect, useRef } from 'react';
import IconButton from '@components/core/IconButton';
import Icon from '../core/Icon';
import { useTranslations } from '../context/TranslationContext';

const AiSearch = ({
    title: _title,
    placeholder: _placeholder,
    className = '',
    isOpen = false,
    onClick,
    onClose,
    onSearch,
}) => {
    const { t } = useTranslations();
    const [isDropdownOpen, setIsDropdownOpen] = useState(isOpen);
    const [query, setQuery] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const dropdownRef = useRef(null);
    const inputRef = useRef(null);

    const placeholder = _placeholder || t('Search for skills (e.g., experience in years for the role)');
    const title = _title || t('Insights');

    useEffect(() => {
        setIsDropdownOpen(isOpen);
    }, [isOpen]);

    useEffect(() => {
        if (isDropdownOpen) {
            inputRef.current?.focus();
            adjustTextareaHeight();
        }
    }, [isDropdownOpen]);

    const toggleDropdown = () => {
        setIsDropdownOpen((prev) => {
            const newState = !prev;
            if (!newState) {
                setIsEditing(false);
                onClose?.();
            }
            return newState;
        });
    };

    const closeDropdown = () => {
        setIsDropdownOpen(false);
        setQuery("");
        $(".ai-search-input").attr("data-search-triggered", "false");
        $(".ai-response-row").remove();
        setIsEditing(false);
        onClose?.();
    };

    const handleSearchChange = () => {
        const text = inputRef.current.innerText.trim();
        setQuery(text);
        setIsEditing(true);
        onSearch?.(text);
    };

    useEffect(() => {
        const input = document.getElementById('user_prompt');
        if (input) {
            input.value = query;
        }
    }, [query]);

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            onClick?.(query);
            inputRef.current.blur();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();

        let text = e.clipboardData.getData('text/plain').trim();
        text = text.replace(/[^\w\s]/gi, '').replace(/<br\s*\/?>/gi, '');
        inputRef.current.innerText = text;
        text = inputRef.current.textContent.trim();
        if (inputRef.current) {
            setQuery(text);
            onSearch?.(text);
        }
    };

    const handleFocus = () => {
        setIsEditing(true);
    };

    const handleBlur = () => {
        setIsEditing(false);
    };

    const adjustTextareaHeight = () => {
        if (inputRef.current) {
            inputRef.current.style.height = 'auto';
        }
    };

    return (
        <div className={`ai-search-container ${className}`} ref={dropdownRef}>
            <button
                type='button'
                className='btn btn-ai-search'
                onClick={toggleDropdown}
                aria-expanded={isDropdownOpen}
                aria-controls='ai-search-dropdown'
            >
                <Icon value='stars-01' />
                {title && <span className='btn-title'>{title}</span>}
            </button>

            {isDropdownOpen && (
                <div id='ai-search-dropdown' className='ai-search-dropdown open'>
                    <div className='search-content-area'>
                        <input type='hidden' id='user_prompt' />
                        <div
                            contentEditable
                            ref={inputRef}
                            placeholder={placeholder}
                            onKeyDown={handleKeyDown}
                            onPaste={handlePaste}
                            onInput={handleSearchChange}
                            className={`ai-search-input ${isEditing ? 'expanded' : ''}`}
                            aria-label={t('Search')}
                            onFocus={handleFocus}
                            onBlur={handleBlur}
                            data-placeholder={placeholder}
                        ></div>
                    </div>
                    <IconButton
                        variant='plain'
                        icon='x-close'
                        label={t('Close search')}
                        className='close-btn'
                        onClick={closeDropdown}
                    />
                </div>
            )}
        </div>
    );
};

export default AiSearch;
